/* src/app/components/notification/notification-details/comment/comment.component.scss */
.media-content {
  width: 90% !important;
}
.media-content .edit-text-box .text-input {
  width: 100% !important;
}
::ng-deep .empty-head-icon {
  padding-top: 5px !important;
  background-image:
    linear-gradient(
      to top,
      #accbee 0%,
      #e7f0fd 100%) !important;
}
input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  padding-bottom: 3px;
  margin: 4px 0px 0px 0px;
  position: relative;
}
/*# sourceMappingURL=comment.component.css.map */
